import { AbstractControl, FormGroup, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import notify from 'devextreme/ui/notify';

type errorId =
  | 'required'
  | 'invalidSubDomain'
  | 'requiredPattern'
  | 'email'
  | 'minlength'
  | 'maxlength';

export function displaySuccess(translationKey: string, translateService: TranslateService): void {
  const message = translateService.instant(translationKey);
  notify({
    message,
    type: 'success',
    displayTime: 3000,
    height: 50,
    width: 500,
  });
}

export function isFormControlError(formControl: AbstractControl | null, errorId: errorId): boolean {
  if (!formControl) {
    return false;
  }
  if (formControl.untouched) {
    return false;
  }
  if (!formControl.errors) {
    return false;
  }
  return !!formControl.errors[errorId];
}

export function createPatchBody(formGroup: UntypedFormGroup): any {
  const bodyArray = [];

  for (const controlName in formGroup.value) {
    if (formGroup.controls[controlName].dirty) {
      bodyArray.push({
        op: 'replace',
        path: `/${controlName}`,
        value: formGroup.value[controlName],
      });
    }
  }

  return bodyArray;
}

export function createInsertBody(formGroup: FormGroup): any {
  const body: { [key: string]: any } = {};

  for (const controlName in formGroup.value) {
    if (formGroup.controls[controlName].dirty) {
      body[controlName] = formGroup.value[controlName];
    }
  }

  return body;
}

export function createPutFormData(formGroup: FormGroup): FormData {
  const formData: FormData = new FormData();

  for (const controlName in formGroup.value) {
    if (formGroup.value[controlName]) {
      if (!(formGroup.controls[controlName] as FormGroup).controls) {
        formData.append(controlName, formGroup.value[controlName]);
      } else {
        for (const subControlName in formGroup.controls[controlName].value) {
          if (formGroup.controls[controlName].value[subControlName]) {
            formData.append(
              `${controlName}[${subControlName}]`,
              formGroup.controls[controlName].value[subControlName]
            );
          }
        }
      }
    }
  }

  return formData;
}
